import type { DetailedHTMLProps, HTMLAttributes } from 'react';
import { forwardRef, useCallback, useEffect, useImperativeHandle, useRef } from 'react';

// TODO replace with useClickOutside

const OutsideClick = forwardRef<
    HTMLDivElement,
    DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> & {
        onClickOutside?: any;
        active: boolean;
        className?: string;
        children?: ReactNode;
        checkAdditionalElement?: string;
        trigger?: ReactElement;
        triggerRef?: HTMLElement;
    }
>(({ active, children, className, onClickOutside, checkAdditionalElement, triggerRef, ...props }, ref) => {
    const node = useRef<HTMLDivElement>(ref as any);

    useImperativeHandle(ref, () => node.current);

    const handleClick = useCallback(
        (e) => {
            if (active) {
                const withinSelf = node.current.contains(e.target);

                if (withinSelf) {
                    return;
                } else {
                    const popper = triggerRef || document.querySelector(checkAdditionalElement || '#popper');
                    const withinPopper = popper && popper.contains(e.target);
                    if (withinPopper) return;
                }

                onClickOutside();
            }
        },
        [active, onClickOutside],
    );

    useEffect(() => {
        if (active) {
            document.addEventListener('mousedown', handleClick, false);

            return () => {
                document.removeEventListener('mousedown', handleClick, false);
            };
        }
    }, [active, handleClick]);

    return (
        <div className={className} ref={node} {...props}>
            {children}
        </div>
    );
});

OutsideClick.displayName = 'OutsideClick';

export { OutsideClick };
